import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import DetailView from '../Common/DetailView';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import buildContextMenu from '../Common/BuildContextMenu';
import StatementStore from '../../stores/StatementStore';
import { withId } from '../Common/Decorators';
import LRS from '../../utils/LRS';

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getMenuItems = () => [
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

const colour = '#E0E0E0';
const StatementItem = ({statement}) => !!statement && (
    <Card className="cent-card">
        <CardHeader
            title="Activity"
            subtitle="Details"
            avatar={<ActivityIcon style={style.icon} color={colour} />}
        />
        <Divider />
        <CardText>
            <div className="cent-flex-row">
                <div className="cent-col-2">
                    <ul className="cent-list-plain">
                        <li><em>Id: {statement.id}</em></li>
                        <li><em>Actor type: </em></li>
                        <li><em>Name: </em></li>
                        <li><em>Object type: </em></li>
                        <li><em>Object name: </em></li>
                        <li><em>Object id: </em></li>
                        <li><em>Verb: </em></li>
                        <li><em>Time: </em></li>
                    </ul>
                </div>
                <div className="cent-col-2">
                    <ul className="cent-list-plain">
                        <li><em>Score: </em></li>
                        <li><em>Success: </em></li>
                        <li><em>Completion: </em></li>
                        <li><em>Stored: </em></li>
                        <li><em>Version: </em></li>
                        <li><em>Registration: </em></li>
                    </ul>
                </div>
            </div>
        </CardText>
    </Card>
);

StatementItem.propTypes = {
    statement: PropTypes.shape({
        id: PropTypes.string.isRequired
    })
};

class Statement extends Component {


    componentWillMount() {
        this.actions = buildContextMenu(getMenuItems());
    }
    // TODO: load single statement

    render() {
        return (
            <DetailView
                title="Statement"
                backButton={true}
                actions={this.actions}
            >
                <div className="cent-cards">
                    <StatementItem statement={this.state.statement}/>
                </div>
            </DetailView>
        );
    }

}

Statement.propTypes = {
    id: PropTypes.string.isRequired
};

Statement.getStores = () => ([StatementStore]);
Statement.calculateState = (prevStore, {id}) => ({
    isFetching: StatementStore.isFetching(),
    statement: StatementStore.getStatement(id)
});

export default withId(Container.create(Statement, {withProps: true}), ({routeParams}) => ({id: routeParams.id || null}));
